import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "My new footer gives you a glimpse into my life",
  "description": "",
  "published": "2011-06-14T00:00:00.000Z",
  "redirect_from": ["/blog/my-footer-gives-you-a-glimpse-into-my-life/swizec/1840"],
  "categories": "750 Words, Buster Benson, Dustin Curtis, Foursquare, Github, My Blog Guest, Twitter, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Over the past week and a half my life has been devoted mostly to studying for exams and absolutely killing the slaughterhouse my university calls "Making sure people learn shit". As a result my coding fingers have been pretty itchy, but I didn't have enough brainpower left to do anything serious.`}</p>
    <p>{`So I decided to spend some of my study breaks doing some housekeeping around the site. This resulted in a pretty awesome super informative footer that has already produced some fine results as far as visitor behaviour goes.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/06/g9XOu4.jpg",
        "alt": null,
        "title": "Super informative footer"
      }}></img></p>
    <p>{`Yes, it's pretty big as far as footers go, but I wanted something that's very airy and looks nice. If it doesn't look like the picture for you, please let me know so I can fix it.`}</p>
    <p>{`The point of this footer is that it isn't just some static "Hey, I'm this guy and I do this stuff, follow me on twitter, be my friend, I'm awesome". No. The only static parts of this monster are the section titles and a sentence or two. Everything else is dynamically updated from the various social and data tracking services I use.`}</p>
    <p>{`My current location is pulled directly from `}<a parentName="p" {...{
        "href": "http://www.foursquare.com/",
        "title": "Foursquare"
      }}>{`Foursquare,`}</a>{` the last few photos are from Instagram, the latest stuff I'm working on is just a list of repositories I last pushed to on `}<a parentName="p" {...{
        "href": "http://github.com",
        "title": "GitHub"
      }}>{`Github`}</a>{`. The part about what I'm listening to is a `}<a parentName="p" {...{
        "href": "http://www.last.fm/widgets/",
        "title": "Last.fm Widget"
      }}>{`last.fm widget`}</a>{` and that awesome thing telling you that I only have about 19k more days to live is a pretty brilliant new site I randomly found ... going to blog about that later this week, because it's just super awesome.`}</p>
    <p>{`Another important bit is the navigation linking visitors to the previous and next post. Now I dont' have any metrics yet, but ever since I added those two links activity surrounding my old posts has shot up infinitely. I say infinitely because there didn't used to be any. People probably thought there was only ever one post on the whole blog :)`}</p>
    <p>{`Originally the idea for this footer came from `}<a parentName="p" {...{
        "href": "http://busterbenson.com/",
        "title": "Buster Benson"
      }}>{`Buster Benson`}</a>{`'s home page. He's the guy who made `}<a parentName="p" {...{
        "href": "http://750words.com",
        "title": "750 Words"
      }}>{`750words.com`}</a>{` and it seems like his home page is pulling data from some of the things he writes on and making real-time analysis of how he's feeling. I wanted to have something like that, but didn't feel like devoting my whole site to it.`}</p>
    <p>{`The answer came when I stumbled upon `}<a parentName="p" {...{
        "href": "http://dustincurtis.com/",
        "title": "Dustin Curtis"
      }}>{`Dustin Curtis`}</a>{`' home page. Everything is just brilliantly styled there, but when I saw how his footer works, I was in love. Suddenly I knew exactly where to put the data about my life and I knew almost exactly what I wanted it to look like.`}</p>
    <p>{`So thanks to @dcurtis and @busterbenson, you probably won't read this, but thanks for the inspiration anyway.`}</p>
    <p>{`Also, if you have any suggestions about what I could add to the footer, do tell. I was thinking about adding a counter for the amount of tasks I've completed lately (`}<a parentName="p" {...{
        "href": "http://www.toggl.com",
        "title": "Toggl.com"
      }}>{`Toggl`}</a>{` has an API), or displaying some of my latest tweets ... perhaps the ones that get retweeted so it isn't too horrible to read.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/750-words-a-day-keeps-the-insanity-away/swizec/1703"
        }}>{`750 words a day keeps the insanity away`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blogs.sitepoint.com/2009/12/10/ten-fat-footers-web-design/"
        }}>{`Ten Fat Footers: How to Make Good Use of that Space at the End of the Page`}</a>{` (blogs.sitepoint.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.bloggingot.com/blogging-tips/3-powerful-website-toolbars-for-bloggers/"
        }}>{`3 Powerful Website Toolbars for Bloggers`}</a>{` (bloggingot.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.clickfire.com/my-blog-guest/"
        }}>{`My Blog Guest - Hype or Monstrous Backlink Machine?`}</a>{` (clickfire.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=24117611-b98a-4a71-8c6a-09648c5d7f0b",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      